import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { HobbiesFilter, HobbiesSorting, Hobby } from '../../lib/types/models/hobby/hobby'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getHobbies<T extends string>(
  input: PaginationRequest<HobbiesFilter, T, T, HobbiesSorting> = {}
) {
  const url = constructApiUrl(API.hobbies.getAll.url, null)
  if (!input.sort) input.sort = { name: 'asc' }
  return restApiClient.url(encodeNestedObject(url, input)).get<PaginationResponse<Hobby>>()
}
